import { BASE_PATH_API } from 'constants/env'
import { useState } from 'react'

const useCartServer = () => {

    const [ listEvents, setListEvents ] = useState(false)

    // va por servicio de Carrito
    const [ respServerList, setRespServerList ] = useState(false)
    const serverListCarts = async ( idSears, event_id ) => {
        // window.localStorage.removeItem('localCartEvents')
        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table-cart?customer_sears_id=${idSears}&gifttable_id=${event_id}`);
            const data = await response.json();
            setRespServerList(data?.data)
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }

    

    // crea el carrito con el post
    const [ respCreateCartS, setRespCreateCartS ] = useState(false)
    const serverCreateCart = async ( eventID, payload ) =>{
        const event_id = String(eventID)

        const header = {
            method: 'POST',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify(payload)
        }

        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table/${event_id}/carts`, header);
            const data = await response.json();
            const newResponse = [{
                cart_id: data?.data?.cart_id,
                gift_table_id: event_id,
                guest_name: null,
                congrats_message: null,
                congrats_to_celebrated_id: null,
                products: [{
                    product_sears_id: payload?.product_sears_id,
                    variant_sears_id: payload?.variant_sears_id,
                    ean: payload?.ean,
                    sku: payload?.sku,
                    children_sku_sears: payload?.children_sku_sears,
                    division_sears_id: payload?.division_sears_id,
                    is_market_place: payload?.is_market_place,
                    quantity: payload?.quantity,
                    quantity_required: payload?.quantity_required,
                    category_sears_ids: payload?.category_sears_ids
                }]
            }]
            setRespCreateCartS(newResponse)
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }
    

    // agrega productos con el patch
    const [ respAddProductS, setRespAddProductS ] = useState(false)
    const serverAddProducts = async ( eventID, payload ) =>{
        const cart_id = String(eventID)

        const header = {
            method: 'PATCH',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify(payload)
        }

        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table-cart/${cart_id}`, header);
            const data = await response.json();

            const prevProducts = [...listEvents[0]?.products]
            const addProduct = data?.data?.products[0]
            prevProducts.push(addProduct)
            const products = prevProducts

            const newResponse = [{
                ...data?.data,
                products
            }] 

            setRespAddProductS(newResponse)

        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }



    // elimina productos con el delete
    const [ respDeleteProductS, setRespDeleteProductS ] = useState(false)
    const serverDeleteProducts = async ( eventID, productID, productSKU ) =>{
        const cart_id = String(eventID)

        const header = {
            method: 'DELETE',
            headers: { 'Content-Type':'application/json' }
        }
        try {
            await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table-cart/${cart_id}?product_sears_id=${productID}&variant_sears_id=${productSKU}`,header);
            setRespDeleteProductS({
                productID,
                productSKU
            })
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }


    return{
        serverListCarts,
        respServerList,
        serverCreateCart,
        respCreateCartS,
        serverAddProducts,
        respAddProductS,
        serverDeleteProducts,
        respDeleteProductS,
        setLastEventsS: setListEvents
    }

}

export default useCartServer